"use strict";export function mockedRequestAnimationFrame(callback){return setTimeout((()=>callback(performance.now())),0)}